import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LocalDataService {
  constructor() {}

  setData(data: any, storageName: string) {
    localStorage.setItem(storageName, JSON.stringify(data));
  }

  getData(storageName: string) {
    let data = localStorage.getItem(storageName);
    return JSON.parse(data);
  }

  clearData(storageName) {
    localStorage.removeItem(storageName);
  }
}
